import { Trans } from "@lingui/macro";

import { useToastNotification } from "src/hooks/useToastNotification";

export const useResendCode = () => {
  const { triggerSuccessNotification } = useToastNotification();

  const notifyEmailSent = (userEmail: string) => {
    triggerSuccessNotification({
      id: "resend-email-verification",
      title: (
        <Trans id="optimised-signup.resend-email.title">Check your inbox</Trans>
      ),
      message: (
        <>
          <Trans id="optimised-signup.resend-email.text">
            We have sent you a new verification code to
          </Trans>{" "}
          <strong>{userEmail}</strong>.
        </>
      ),
    });
  };

  return { notifyEmailSent };
};
